import * as Yup from 'yup'

export const memberID = Yup.string()
    .trim()
    .matches(/^[0123456789]*$/, 'Invalid format')
    .min(11, 'Must be 11 digits')
    .max(11, 'Must be 11 digits')

export const medicaidID = Yup.string()
    .trim()
    .matches(/^[0123456789]*$/, 'Invalid format')
    .min(12, 'Must be 12 digits')
    .max(12, 'Must be 12 digits')

export const currency = Yup.string()
    .matches(/^\$?(?=\(.*\)|[^()]*$)\(?\d{1,3}(,?\d{3})?(\.\d\d?)?\)?$/, 'Not a valid currency value')
